<template>
  <div class="privacy-page">
    <!-- Header -->
    <PageTitle pageTitle="PRIVACY POLICY"></PageTitle>
    <Privacy></Privacy>
  </div>
</template>

<script>
import Privacy from "@/components/Privacy/Privacy";
// import PageTitle from "@/components/PageTitle/PageTitle";
export default {
  components: {
    Privacy,
    // PageTitle
  }
};
</script>

<style></style>
